export default __webpack_public_path__ + "static/media/producto-10.b9709156.jpg";